import HeroHeader from 'modules/common/HeroHeader';
import {updateProgress} from 'modules/user/actions/progress';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {compose, lifecycle, withPropsOnChange} from 'recompose';
import {checkQuizResult, resetTasks} from '../actions';
import {QuizResult, QuizTask, QuizTimeLine} from '../components';

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPosition: 0,
      score: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {step} = this.props;
    if (step.id !== nextProps.step.id) {
      this.setState({currentPosition: 0, score: 0});
    }
  }

  checkResult = ({callback, id, answer, quizAttempt, relatedSteps}) => {
    const {step, dispatch} = this.props;
    const {currentPosition} = this.state;
    // if we are at first position, we set the progress as started
    const modifiedCallback =
      currentPosition === 0
        ? (data) => {
            callback(data);
            dispatch(
              updateProgress({id: step.id, related_steps: relatedSteps}),
            );
          }
        : callback;
    dispatch(
      checkQuizResult({
        callback: modifiedCallback,
        id,
        answer,
        quizAttempt,
      }),
    );
  };

  next = (quizTotalResult) => {
    const {relatedSteps, step, stepProgress, taskCount, dispatch} = this.props;
    const {currentPosition} = this.state;
    const last = currentPosition >= taskCount - 1;
    const won =
      quizTotalResult.answers_correct - quizTotalResult.min_score >= 0;
    if (last && won) {
      if (stepProgress !== 'completed') {
        this.setState({score: 15});
      }
      dispatch(
        updateProgress({
          id: step.id,
          completed: true,
          related_steps: relatedSteps,
        }),
      );
    }
    this.setState((prevState) => ({
      currentPosition: prevState.currentPosition + 1,
      quizTotalResult,
    }));
  };

  tryAgain = () => {
    this.setState({
      currentPosition: 0,
      score: 0,
    });
    this.props.dispatch(resetTasks());
  };

  render() {
    const {
      authenticated,
      nextStepProps,
      step,
      taskCount,
      trackSlug,
      isDegree,
      intl: {formatMessage},
    } = this.props;
    const {currentPosition} = this.state;
    const finished = currentPosition >= taskCount;
    const last = currentPosition >= taskCount - 1;
    return (
      <div className="bg-white">
        <HeroHeader
          title={
            (!authenticated &&
              formatMessage({
                id: 'challenge',
              })) ||
            (currentPosition + 1 <= taskCount
              ? `${formatMessage({id: 'quiz'})}: ${formatMessage({
                  id: 'question',
                })} ${currentPosition + 1} ${formatMessage({
                  id: 'of',
                })} ${taskCount}`
              : formatMessage({id: 'quiz_finished'}))
          }
          trackSlug={trackSlug}
          isDegree={isDegree}
        />
        {authenticated && (
          <div>
            {!finished && (
              <div className="pv1 center">
                <QuizTimeLine
                  currentPosition={currentPosition}
                  tasks={step.quiz.quiztaskSet.edges}
                />
                <QuizTask
                  {...step.quiz.quiztaskSet.edges[currentPosition].node}
                  checkResult={this.checkResult}
                  last={last}
                  next={this.next}
                  isNanoDegree={isDegree}
                />
              </div>
            )}
            {finished && (
              <QuizResult
                nextStepProps={nextStepProps}
                quizTotalResult={this.state.quizTotalResult}
                tryAgain={this.tryAgain}
                score={this.state.score}
                stepId={step.id}
                trackSlug={trackSlug}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

Quiz.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  nextStepProps: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
  stepProgress: PropTypes.string.isRequired,
  relatedSteps: PropTypes.array.isRequired,
  isDegree: PropTypes.bool.isRequired,
  intl: PropTypes.object,
  dispatch: PropTypes.func,
};

const enhance = compose(
  withPropsOnChange(['step'], ({step}) => ({
    taskCount: step.quiz.quiztaskSet && step.quiz.quiztaskSet.edges.length,
  })),
  connect(({user: {progress}}, ownProps) => ({
    stepProgress:
      (progress.step && progress.step[ownProps.step.id]) || 'not started',
  })),
  lifecycle({
    componentDidMount() {
      this.props.dispatch(resetTasks());
    },
  }),
  injectIntl,
);

export default enhance(Quiz);
